module.exports = __webpack_public_path__ + "static/desktop/img/life-3.f1684d17.jpg";